import decode from "jwt-decode";

type TokenPayload = {
  userId?: string;
  adminRole?: string;
  exp?: number;
};

export const getToken = () => { return localStorage.getItem('token') };

export const hasToken = () => {
  const token = getToken();
  return validToken(token);
};

const decodeToken = (token: string | null): TokenPayload | null => {
  if (token === null || token === "null" || token === "") return null;

  try {
    return decode<TokenPayload>(token);
  } catch (err) {
    // Not a JWT at all - treat it exactly like having no token.
    return null;
  }
};

export const hasStoredToken = () => {
  const token = getToken();
  return token !== null && token !== "null" && token !== "";
};

export const validToken = (token: string | null) => {
  const decoded = decodeToken(token);
  if (!decoded) return false;

  // exp is in seconds. A token with no exp claim has no expiry to enforce.
  return decoded.exp === undefined || decoded.exp * 1000 > Date.now();
};

export const setToken = (token: string) => {
  localStorage.setItem("token", token);
};

export const destroyToken = () => {
  localStorage.setItem("token", "");
};

export const tokenIsAdmin = (): boolean => {
  const decoded = decodeToken(getToken());

  return (
    !!decoded &&
    (decoded.adminRole === "admin" || decoded.adminRole === "superadmin")
  );
};
